import { Box, Flex, Text } from "@chakra-ui/react";
import { FC } from "react";
import { WebsiteStore } from "../../../../../utils/editor";
import Button from "../../../../../components/Button";
import { Link } from "react-router-dom";

type CloseBtnProps = {
  onClose: () => void;
};
const CloseBtn: FC<CloseBtnProps> = ({ onClose }) => {
  return (
    <Button
      w={"48px"}
      px={0}
      py={0}
      hover={"transparent"}
      minW="fit-content"
      h={"48px"}
      bg={"#F9F9F9"}
      borderRadius={"50px"}
      onClick={onClose}
      label="Close"
      text={
        <svg
          width="16"
          height="15"
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="15.1036"
            y1="0.603553"
            x2="1.60355"
            y2="14.1036"
            stroke="black"
          />
          <line
            y1="-0.5"
            x2="19.0919"
            y2="-0.5"
            transform="matrix(0.707107 0.707107 0.707107 -0.707107 1.25 0.25)"
            stroke="black"
          />
        </svg>
      }
    />
  );
};

type CheckInDrawerProps = {
  onClose: () => void;
};

const CheckInDrawer: FC<CheckInDrawerProps> = ({ onClose }) => {
  const handleClose = () => {
    WebsiteStore.isCheckInDrawerOpen = false;
    onClose();
  };

  return (
    <Flex
      w={"full"}
      flexDirection={"column"}
      gap={"8"}
      overflowY={"scroll"}
      className={"no-scrollbar"}
      px={{ base: "1.5rem", md: "1.5rem" }}
      fontFamily={"font4"}
      h={"100%"}
    >
      <Flex w={"100%"} flexDir={"row"} justifyContent={"space-between"} mt={8}>
        <Text fontSize={"32px"} fontFamily={"font4"}>
          Check In Guests
        </Text>
        <CloseBtn onClose={handleClose} />
      </Flex>

      <Box>
        <Text fontSize="lg" fontWeight={"500"} mb={3}>
          Go here to check in guests for your event.
        </Text>
        <Text lineHeight="1.7">
          Navigate to our secure check-in portal where you can easily manage and
          track guest arrivals. The system provides real-time updates and a
          streamlined experience for both hosts and attendees.
        </Text>
      </Box>

      <Link to="https://check-in.weddn.co/login">
        <Button
          bg="black"
          color="white"
          borderRadius="full"
          px="1.5rem"
          h="52px"
          w="full"
          fontFamily="font4"
          text="Check In Guests"
        />
      </Link>
    </Flex>
  );
};

export default CheckInDrawer;
